import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.field), _mergeProps(_ctx.$attrs, {
    items: _ctx.people,
    "item-title": _ctx.free ? 'email' : 'name',
    "item-value": _ctx.free ? 'email' : 'user',
    "return-object": false,
    "filter-keys": ['title', 'raw.name'],
    "auto-select-first": ""
  }), {
    item: _withCtx(({item, props}) => [
      _createVNode(_component_v_list_item, _mergeProps(props, { title: undefined }), {
        default: _withCtx(() => [
          _createVNode(_component_ontos_person_line, {
            user: item.user,
            email: item.email,
            name: item.name,
            photo: item.photo
          }, null, 8, ["user", "email", "name", "photo"])
        ]),
        _: 2
      }, 1040)
    ]),
    selection: _withCtx(({item}) => [
      (typeof item === 'object')
        ? (_openBlock(), _createBlock(_component_ontos_person_line, {
            key: 0,
            class: "person-select-chosen",
            dense: "",
            user: item.user,
            email: item.email,
            name: item.name,
            photo: item.photo
          }, null, 8, ["user", "email", "name", "photo"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item), 1))
    ]),
    _: 1
  }, 16, ["items", "item-title", "item-value"]))
}